var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "csp-layout-default",
    [
      _c("div", { staticClass: "header" }, [
        _c("h1", [
          _vm._v("\n            Aufnahme Ihrer Schadeninformationen\n        "),
        ]),
      ]),
      _vm._v(" "),
      _vm.isLoadingLoginStatus
        ? _c("b-alert", { attrs: { show: "", variant: "info" } }, [
            _vm._v("\n        Initialisiere Unfallerfassung...\n    "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hasLoginStatusError
        ? _c("b-alert", { attrs: { show: "", variant: "warning" } }, [
            _vm._v(
              "\n        Die Sitzung ist abgelaufen. Bitte Scannen Sie den QR-Code erneut.\n    "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isUserLoggedIn ? _c("router-view") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }